
import {
  uploadFile
} from "../API/api";
import OSS from 'ali-oss'
const uploadMixin = {
  methods: {
    // 图片上传至 oss
    async imgUpload(opt,type) {
        // 获取文件后缀
      const size=opt.file.size
      if((size/1048576)>100 ){
          this.$message.warning(`请上传100MB以内的文件`);
          return;
      }
      let  client,credentials
      try {
        const res = await this.$http.post(uploadFile.getStsAuth, {});
        if (res.data.retCode === 0) {
          credentials = res.data.retData;
           client = new OSS({
              region: 'oss-cn-shanghai',
              accessKeyId: credentials.accessKeyId,
              accessKeySecret: credentials.accessKeySecret,
              stsToken: credentials.securityToken,
              bucket: 'excalibur-work-sh'
            }

          );
        }
      } catch (error) {
        this.$message.error(`${error}`);
        return;
      }
      const timestamp=(Date.parse(new Date()))/1000;
      const randomNumber=Math.round(Math.random()*100)
      const fileName=`${timestamp}${randomNumber}${opt.file.name}`
      const id=JSON.parse(localStorage.getItem("userInfo")).id;
      let result = await client.put(`${credentials.filePath}${id}/${fileName}`, opt.file)
      let newUrl = credentials.url.replace('http://', 'https://');
      const allInfo={
        name:opt.file.name,
        url:`${newUrl}${credentials.filePath}${id}/${fileName}`
      }
      return allInfo;
    }
  }
};

export default uploadMixin;
